<p-tabView class="a-example-full-width-alterno-content">
    <p-tabPanel header="Mantenimiento Chofer">
        <app-mantenimiento-chofer></app-mantenimiento-chofer>
    </p-tabPanel>
    <p-tabPanel header="Mantenimiento Camion">
        <app-mantenimiento-camion></app-mantenimiento-camion>
    </p-tabPanel>
    <p-tabPanel header="Mantenimiento Carreta">
        <app-mantenimiento-carreta></app-mantenimiento-carreta>
    </p-tabPanel>
</p-tabView>